import { DataUtilities } from "../../DataUtilities";
import { IDataDefinition } from "../Definitions/IDataDefinition";
import { ObjectDataDefinition } from "../Definitions/ObjectDataDefinition";
import { DataDefinition } from "../DataDefinition";
import { DataStructureDifferences } from "./DataStructureDifferences";

export class AddFieldToDataStructure implements DataStructureDifferences {
    field: IDataDefinition;
    path: string;
    index?: number;

    constructor(field: IDataDefinition, path: string, index?: number) {
        this.field = field;
        this.path = path;
        this.index = index;
    }

    getMessage() {
        const pieces: string[] = this.path.split(".");
        const path = pieces.length > 1 ? pieces.join(" -> ") : "root";
        return `New Field ${this.field.name} to ${path}`;
    }

    apply(def: DataDefinition) {
        let pieces: string[] = this.path.split(".");

        if (pieces.length === 1) {
            if (this.field.owner) {
                def.getValueObject()[this.field.name] = this.field.owner?.getValueObject()[this.field.name];
            }
            this.field.owner = def;
            def.fields.push(this.field);
        } else if (pieces.length > 1) {
            pieces = pieces.slice(0, -1);
            let parentPath = pieces.join(".");
            let parentField = DataUtilities.getFieldFromDataDefinitionByName(
                def.fields,
                parentPath
            ) as ObjectDataDefinition;

            this.field.owner = parentField;

            if (this.index !== undefined) {
                parentField.fields.splice(this.index, 0, this.field);
            } else {
                parentField.fields.push(this.field);
            }
        }
    }
}
